/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Rosy_Cat_FlowInputs */

const en_clear_rosy_cat_flow = /** @type {(inputs: Clear_Rosy_Cat_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to share content`)
};

const de_clear_rosy_cat_flow = /** @type {(inputs: Clear_Rosy_Cat_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed to share content" |
*
* @param {Clear_Rosy_Cat_FlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const clear_rosy_cat_flow = /** @type {((inputs?: Clear_Rosy_Cat_FlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Rosy_Cat_FlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clear_rosy_cat_flow(inputs)
	return de_clear_rosy_cat_flow(inputs)
});